import { FC, useCallback } from "react";
import { useParams } from "react-router-dom";
import { ProviderInvoiceService } from "../../../../../services/providerInvoices/providerInvoiceService";
import { ProviderInvoicesApiResponse } from "../../../../../type/entities/provider-invoice-type";
import useFetch from "../../../../../hooks/useFetch";
import FormGroup from "../../../../../layout/shared/form-group";
import { Input, Textarea } from "rizzui";
import moment from "moment";
import { usePrivilege } from "../../../../../components/priviledge/PriviledgeProvider";


interface ProviderInvoiceInfoProps { }

const ProviderInvoicesInfo: FC<ProviderInvoiceInfoProps> = () => {

    // HOOKS

    const { id = '' } = useParams<{ id: string }>();
    const service = new ProviderInvoiceService();
    const { userCan } = usePrivilege();

    // DATA FETCHING

    //--------------------------------------------------------------------------------------------------------------
    /**
     *  @EN FETCHES PROVIDER INVOICE DATA BY ID.
     *  @ES OBTIENE LOS DATOS DE UNA FACTURA DE PROVEEDOR POR SU ID.
     */
    //--------------------------------------------------------------------------------------------------------------
    const [data, loadingProvider, error, refetch] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getProviderInvoiceById(id);
        return response.getResponseData() as ProviderInvoicesApiResponse;
    }, [id]));
    //--------------------------------------------------------------------------------------------------------------
    
    // RENDER

    return (
        <>
            <div className="@container">
                <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200">
                    <FormGroup
                        title="Proveedor"
                        description="Datos del proveedor"
                        className='pt-4'
                        titleCols='@md:col-span-2'
                        childCols='@md:col-span-10 md:grid-cols-4'
                    >
                        {userCan('list', 'company') && (
                            <Input
                                disabled
                                label="Proveedor"
                                value={data?.company?.name || ''}
                            />
                        )}

                        <Input
                            disabled
                            label="Proveedor"
                            value={data?.provider?.companyName || ''}
                        />

                        <Input
                            disabled
                            label="CIF del Proveedor"
                            value={data?.provider?.cif || ''}
                        />

                        <Input
                            disabled
                            label="email del proveedor"
                            value={data?.provider?.email || ''}
                        />

                        <Input
                            disabled
                            label="Teléfono del proveedor"
                            value={data?.provider?.telephone || ''}
                        />

                    </FormGroup>

                    <FormGroup
                        title="Información general"
                        description="Datos principales"
                        className='pt-4'
                        titleCols='@md:col-span-2'
                        childCols='@md:col-span-10 md:grid-cols-4'
                    >
                        <Input
                            className="col-span-2"
                            disabled
                            label="Número de factura"
                            value={data?.number || ''}
                        />

                        <Input
                            disabled
                            label="Fecha de emisión"
                            value={data?.invoiceDate ? moment(data?.invoiceDate.date).format('DD/MM/YYYY') : ''}
                        />

                        <Input
                            disabled
                            label="Fecha de pago"
                            value={data?.paymentDate ? moment(data?.paymentDate.date).format('DD/MM/YYYY') : ''}
                        />

                        <Input
                            className="col-span-2"
                            disabled
                            label="Importe Base"
                            value={data?.totalAmount?.toFixed(2) || ''}
                        />

                        <Input
                            className="col-span-2"
                            disabled
                            label="IVA (%)"
                            value={data?.ivaTax || ''}
                        />

                        <Input
                            className="col-span-2"
                            disabled
                            label="Cantidad (kg)"
                            value={data?.kgQuantity || ''}
                        />

                        <Input
                            className="col-span-2"
                            disabled
                            label="Precio (€/kg)"
                            value={data?.unitPrice?.toFixed(2) || ''}
                        />

                        <Input
                            className="col-span-4"
                            disabled
                            label="Total (€)"
                            value={(data?.totalAmount * (100 + data?.ivaTax) / 100).toFixed(2)}
                        />

                        <Textarea 
                            className="col-span-4"
                            disabled
                            label="Comentarios"
                            value={data?.comments || ''}
                        />

                    </FormGroup>
                </div>
            </div>
        </>
    )
};

export default ProviderInvoicesInfo;